import { render, staticRenderFns } from "./CookieInfo.vue?vue&type=template&id=54447058&scoped=true&"
import script from "./CookieInfo.vue?vue&type=script&lang=js&"
export * from "./CookieInfo.vue?vue&type=script&lang=js&"
import style0 from "./CookieInfo.vue?vue&type=style&index=0&id=54447058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54447058",
  null
  
)

export default component.exports